import { render, staticRenderFns } from "./RankUsersComponent.vue?vue&type=template&id=4aa21c27&scoped=true&"
import script from "./RankUsersComponent.vue?vue&type=script&lang=js&"
export * from "./RankUsersComponent.vue?vue&type=script&lang=js&"
import style0 from "./RankUsersComponent.vue?vue&type=style&index=0&id=4aa21c27&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa21c27",
  null
  
)

export default component.exports